import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionMarketplaceCardV2 from "./component";
const mapStateToProps = ({
    postInspectionDiy: { inspectionResponse },
    user: { userId, secureToken }
}) => {
    return {
        inspectionResponse,
        userId,
        secureToken
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PostInspectionMarketplaceCardV2);
